@if (isOpen && currentImage) {
  <div class="ticket-image-viewer" (click)="close()">
    <section class="ticket-image-viewer__dialog" role="dialog" aria-modal="true" aria-label="Ticket image viewer" (click)="$event.stopPropagation()">
      <header class="ticket-image-viewer__header">
        <span>{{ activeIndex + 1 }} of {{ images.length }}</span>
        <button type="button" aria-label="Close image viewer" (click)="close()"><ion-icon name="close-outline"></ion-icon></button>
      </header>

      <div class="ticket-image-viewer__stage" [class.is-carousel]="hasMultipleImages" [class.is-dragging]="isDragging" (pointerdown)="startDrag($event)" (pointermove)="moveDrag($event)" (pointerup)="endDrag($event)" (pointercancel)="endDrag($event)" (dblclick)="advanceZoom()">
        <img [src]="currentImage.src" [alt]="currentImage.alt" [style.transform]="imageTransform" />
        @if (hasMultipleImages) {
          <button type="button" class="ticket-image-viewer__arrow ticket-image-viewer__arrow--previous" aria-label="Show previous image" (click)="showPrevious()"><ion-icon name="chevron-back-outline"></ion-icon></button>
          <button type="button" class="ticket-image-viewer__arrow ticket-image-viewer__arrow--next" aria-label="Show next image" (click)="showNext()"><ion-icon name="chevron-forward-outline"></ion-icon></button>
        }
      </div>

      <footer class="ticket-image-viewer__footer">
        <span>{{ currentImage.label }}</span>
        @if (hasMultipleImages) {
          <div class="ticket-image-viewer__dots" aria-label="Image navigation">
            @for (image of images; track image.id; let index = $index) {
              <button type="button" [class.is-active]="index === activeIndex" [attr.aria-label]="'Show image ' + (index + 1)" [attr.aria-current]="index === activeIndex ? 'true' : null" (click)="showImage(index)"></button>
            }
          </div>
        }
      </footer>
    </section>
  </div>
}
